import { StakeDbDashboardStakeItem } from '@/types/stake-db';
import { Tables } from '../../pools/table/Tables';
import { GridColDef } from '@mui/x-data-grid';
import { StakeDbDashboardStakeColumns } from '../table/StakeDbColumnsData';
import { Button, Typography } from '@mui/material';
import { now } from '@/lib/dayjs';
import { fontWeight } from '@/theme';

export default function StakeList({ list }: { list: StakeDbDashboardStakeItem[] | undefined }) {
  if (!list) {
    return <>stake empty</>;
  }

  const columns: GridColDef[] = [
    ...StakeDbDashboardStakeColumns,
    {
      minWidth: 200,
      field: 'shortTxHash',
      headerName: 'hash',
      headerAlign: 'center',
      align: 'left',
      sortable: false,
      renderCell: (params) => (
        <Button color="primary" onClick={() => handleButtonClick(params.row.txHash)}>
          {params.row.shortTxHash}
        </Button>
      ),
    },
  ];

  const handleButtonClick = (aData: string) => {
    const src =
      process.env.NODE_ENV === 'development'
        ? `https://amoy.polygonscan.com/tx/${aData}`
        : `https://polygonscan.com/tx/${aData}`;
    window.open(src);
  };

  return (
    <>
      <Typography variant="h5" fontWeight={fontWeight.Bold} textAlign="left">
        Stake
      </Typography>
      <Tables list={list} columns={columns} csvName={`stake-db-stake-${now()}`} />
    </>
  );
}
